export default __webpack_public_path__ + "static/media/weekly_mind_body.896bd3b5.webp";